import React from "react";
import { Select, MenuItem } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export function LanguageSwitcher() {
    const { i18n } = useTranslation();
    const theme = useTheme();
    return (
        <Select
            value={i18n.language}
            onChange={e => i18n.changeLanguage(e.target.value)}
            size="small"
            sx={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                minWidth: 120,
                ml: 2,
                "& .MuiSelect-icon": { color: theme.palette.text.primary }
            }}
        >
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="es">Español</MenuItem>
            <MenuItem value="ca">Català</MenuItem>
            <MenuItem value="fr">Français</MenuItem>
            <MenuItem value="eu">Euskara</MenuItem>
            <MenuItem value="pt">Português</MenuItem>
            <MenuItem value="it">Italiano</MenuItem>
        </Select>
    );
} 